export default "__VITE_ASSET__hD5q8nyZ__"